import { FC } from 'react';
import { Check } from 'lucide-react';

interface RuleCreationStepperProps {
  steps: string[];
  currentStep: number;
}

export const RuleCreationStepper: FC<RuleCreationStepperProps> = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between mt-4">
      {steps.map((step, index) => (
        <div key={step} className="flex items-center">
          <div className="flex items-center">
            <div
              className={`flex items-center justify-center w-8 h-8 rounded-full border-2 transition-colors ${
                index < currentStep
                  ? 'bg-[#EA5B24] border-[#EA5B24] text-white'
                  : index === currentStep
                    ? 'border-[#EA5B24] text-[#EA5B24] bg-background'
                    : 'border-muted-foreground text-muted-foreground bg-background'
              }`}
            >
              {index < currentStep ? (
                <Check className="w-4 h-4" />
              ) : (
                <span className="text-sm font-medium">{index + 1}</span>
              )}
            </div>
            <div className="ml-3">
              <p
                className={`text-sm font-medium transition-colors ${
                  index <= currentStep ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step}
              </p>
            </div>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`w-12 h-px mx-4 transition-colors ${
                index < currentStep ? 'bg-[#EA5B24]' : 'bg-muted'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};
